<template>
  <TariffCategoryPicker
    :isClient="isClient"
    @isClientChange="handleIsClientChange"
    v-if="showIsClientPicker"></TariffCategoryPicker>
  <p class="tariff-view-caption" v-if="showIsClientPicker && isClient" v-html="simTariffClientText"></p>
  <p class="tariff-view-caption" v-if="showIsClientPicker && !isClient" v-html="simTariffNonClientText"></p>
  <TariffCardSlider :isClient="isClient" :showCarrierInfo="showCarrierInfo" v-if="groups">
    <swiper
      class="mobiles-swiper"
      :modules="modules"
      :slides-per-view="1.1"
      :space-between="20"
      :breakpoints="swiperOptions.breakpoints"
      :navigation="({
        enabled: true,
        nextEl: '.to-right',
        prevEl: '.to-left',
      } as any)"
      :pagination="({
          el: '.swiper-pagination',
          type: 'bullets',
          dynamicBullets: true,
          clickable: true
        } as any)">
      <swiper-slide v-for="group in urlWhitelistedGroups" :key="group.group_id" :style="`order: ${group?.order}`"
        ><TariffCard
          :group="group"
          :isClient="isClient"
          :include-iptv="includeIptv"
          :iptv-price="iptvPrice"
          :show-bottom-caption="showBottomCaption"
          :show-carrier-info="true"
          :default-programs-ids="defaultProgramsIds"
          :promo-label="promoModalLabel"
          :promo-card-id="Number(promoCardId)"
          :promo-from="promoFrom"
          :promo-until="promoUntil"
          @isClientChanged="handleIsClientChange"
          @tariffChosen="showOrderForm"
          @promoLabelClicked="
            includeIptv
              ? showPromoIptvModal($event)
              : !isClient
              ? showPromoNonClientModal($event)
              : showPromoModal($event)
          "
          @moreInfoClicked="showMoreInfoModal"
          @giftLabelClicked="showGiftModal"
      /></swiper-slide>

      <div class="swiper-navigation-item to-left">
        <span class="icon icon__arrow-blue">
          <inline-svg :src="arrowSvg" aria-label="My image"></inline-svg>
        </span>
      </div>
      <div class="swiper-navigation-item to-right">
        <span class="icon icon__arrow-blue">
          <inline-svg :src="arrowSvg" aria-label="My image"></inline-svg>
        </span>
      </div>

      <div class="swiper-pagination"></div>
    </swiper>
  </TariffCardSlider>
  <ModalView v-if="isOrderFormVisible" @hide="hideOrderForm" class="modal-view-lg">
    <template v-slot:header>
      <h2 v-if="includeIptv || !isClient">Nezávazná poptávka tarifu</h2>
      <h2 v-else>Objednávka tarifu</h2>
      <p style="margin-left: 1rem">Krok {{ orderFormStepCurrent }} / {{ orderFormStepsTotal }}</p>
    </template>
    <TariffOrderForm
      :program="orderFormProgram"
      :isClient="formType"
      :includeIptv="includeIptv"
      :iptvPrice="iptvPrice"
      :gtm-event-prefix="gtmEventPrefix"
      @stepChanged="handleStepChange"></TariffOrderForm>

    <template v-if="isClient && !includeIptv" v-slot:footer>
      <p :class="{ 'mb-1': !isClient, 'mb-0': isClient }" class="text-sm">
        Pokud službu neaktivujete do 30 dnů, budeme vám dle
        <a href="/dokumenty/vseobecne-podminky/" target="_blank">smluvních podmínek</a> účtovat zřizovací poplatek 150
        Kč.
        <span class="text-sm">
          Můžeme si také vyžádat zálohu na služby ve výši jednoho měsíčního paušálu, minimálně však 180 Kč.
        </span>
      </p>

      <p class="text-sm mb-0" v-if="!isClient">
        Odesláním formuláře s telefonním číslem souhlasíte se zpracováním údaje a s kontaktováním s nabídkou služeb.
        Více o ochraně soukromí a možnostech odvolání souhlasu naleznete
        <a href="/ochrana-soukromi/" target="_blank">zde</a>.
      </p>
    </template>
  </ModalView>
  <ModalView v-if="isPromoNonClientModalVisible" @hide="hidePromoNonClientModal" class="modal-view-md">
    <template v-slot:header>
      <h6 v-html="promoModalHeading"></h6>
    </template>
    <div class="text-content" v-html="promoModalNonClientContent"></div>
  </ModalView>
  <ModalView v-if="isPromoIptvModalVisible" @hide="hidePromoIptvModal" class="modal-view-md">
    <template v-slot:header>
      <h6 v-html="promoModalHeading"></h6>
    </template>
    <div class="text-content" v-html="promoModalIptvContent"></div>
  </ModalView>
  <ModalView v-if="isPromoModalVisible" @hide="hidePromoModal" class="modal-view-md">
    <template v-slot:header>
      <h6 v-html="promoModalHeading"></h6>
    </template>
    <div class="text-content" v-html="promoModalContent"></div>
  </ModalView>
  <ModalView v-if="isMoreInfoModalVisible" @hide="hideMoreInfoModal" class="modal-view-md">
    <template v-slot:header>
      <h6 v-html="includeIptv ? `IPTV + ${orderFormProgram?.name}` : orderFormProgram?.name"></h6>
    </template>

    <div class="text-content">
      <template v-if="includeIptv">
        <div v-if="isClient" class="d-flex mb-3 align-items-start">
          <div class="tariff-icon-bg mt-1">
            <inline-svg :src="piggyBankSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
          </div>
          <div class="ml-3">
            <h5>Nejvýhodnější cena v kombinaci s IPTV</h5>
            <p>
              Ještě nejste našimi klienty? Nevadí, i tak vám můžeme mobilní služby v kombinaci se službou IPTV nabídnout
              za stejných podmínek, jako našim klientům. Cena za IPTV a mobilní tarif je
              {{ orderFormProgram?.price_vat + (includeIptv ? 99 : 0) }} Kč měsíčně (vč. DPH).
            </p>
          </div>
        </div>
        <div class="d-flex mb-3 align-items-start">
          <div class="tariff-icon-bg mt-1">
            <inline-svg :src="remoteSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
          </div>
          <div class="ml-3">
            <h5 class="pt-1"><strong>100+</strong> televizních stanic</h5>
            <p>
              <span
                >Vyberte si z široké nabídky TV programů a sledujte své oblíbené pořady. Stačí vám k tomu jen
                internetové připojení.</span
              >
            </p>
          </div>
        </div>
        <div class="d-flex mb-3 align-items-start">
          <div class="tariff-icon-bg mt-1">
            <inline-svg :src="networkSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
          </div>
          <div class="ml-3">
            <h5 class="pt-1"><strong>Multiplatformní</strong></h5>
            <p>
              <span
                >Televizi od PODY můžete kromě své chytré TV sledovat až na 4 netelevizních zařízeních, a to
                prostřednictvím tabletu, notebooku, mobilu nebo webového prohlížeče.</span
              >
            </p>
          </div>
        </div>
        <div class="d-flex mb-3 align-items-start">
          <div class="tariff-icon-bg mt-1">
            <inline-svg :src="playSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
          </div>
          <div class="ml-3">
            <h5 class="pt-1"><strong>Chytré funkce</strong></h5>
            <p>
              <span
                >Objevte užitečné funkce, jako je možnost až 7 dní zpětného přehrávání, archiv nebo 20 hodin pro
                nahrávání vašich oblíbených pořadů.</span
              >
            </p>
          </div>
        </div>
        <hr />
      </template>
      <div class="d-flex mb-3 align-items-start">
        <div class="tariff-icon-bg mt-1">
          <inline-svg :src="callSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
        </div>
        <div class="ml-3">
          <h5 class="pt-1">
            <template v-if="orderFormProgram?.incl_min_unlimited">Neomezené volání</template>
            <template v-else-if="orderFormProgram?.incl_min > 0">
              {{ orderFormProgram?.incl_min }} volných minut
              <span v-if="orderFormProgram?.group_id == 4">+ neomezeně v síti PODA</span></template
            >
            <template v-else-if="orderFormProgram?.incl_min == 0"> <strong>1,50</strong> Kč/minuta </template>
          </h5>
          <p>
            <span v-if="orderFormProgram?.incl_min_unlimited">Tento tarif zahrnuje neomezené volání.</span>
            <span v-else-if="orderFormProgram?.group_id == 4">
              Tento tarif obsahuje neomezené volání v síti PODA a {{ orderFormProgram?.incl_min }} volných minut do
              ostatních sítí. Po jejich vyčerpání je cena za volání 1,50 Kč/min (včetně DPH).
            </span>

            <span v-else-if="orderFormProgram?.incl_min == 0">
              Tento tarif obsahuje neobsahuje žádné volné minuty a platíte pouze za to, co provoláte.
            </span>
            <span v-else
              >Tento tarif obsahuje {{ orderFormProgram?.incl_min }} volných minut. Po jejich vyčerpání je cena za
              volání 1,50 Kč/min (včetně DPH).</span
            >
          </p>
        </div>
      </div>
      <div class="d-flex mb-3 align-items-start">
        <div class="tariff-icon-bg mt-1">
          <inline-svg :src="messageSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
        </div>
        <div class="ml-3">
          <h5>
            <template v-if="orderFormProgram?.incl_sms === 0"><strong>1,50</strong> Kč/SMS</template>
            <template v-if="orderFormProgram?.incl_sms > 0">
              <strong>{{ orderFormProgram.incl_sms }}</strong> volných SMS
            </template>
          </h5>
          <p v-if="orderFormProgram?.incl_sms === 0">
            Tento tarif neobsahuje žádné volné SMS a platíte pouze za to, co odešlete.
          </p>
          <p v-if="orderFormProgram?.incl_sms > 0">
            Tento tarif obsahuje {{ orderFormProgram.incl_sms }} volných SMS. Po vyčerpání volných SMS je cena za SMS
            1,50 Kč (včetně DPH).
          </p>
        </div>
      </div>
      <div class="d-flex mb-3 align-items-start" v-if="orderFormProgram?.incl_data > 0">
        <div class="tariff-icon-bg mt-1">
          <inline-svg :src="dataSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
        </div>
        <div class="ml-3">
          <h5>
            {{ dataTitle }}
          </h5>
          <p>
            Tento tarif obsahuje
            {{ dataTitle }}.
            <template v-if="orderFormProgram?.incl_data == 30000"
              >Prvních 10 GB čerpáte plnou rychlostí (v&nbsp;závislosti na dostupné síti), zbývající objem potom stále
              vynikající rychlostí 2&nbsp;Mb/s.
            </template>
            <template v-if="orderFormProgram?.incl_data == 40000"
              >Prvních 20 GB čerpáte plnou rychlostí (v&nbsp;závislosti na dostupné síti), zbývající objem potom stále
              vynikající rychlostí 2&nbsp;Mb/s.
            </template>
          </p>
        </div>
      </div>
      <div v-if="isClient && !includeIptv" class="d-flex mb-3 align-items-start">
        <div class="tariff-icon-bg mt-1">
          <inline-svg :src="piggyBankSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
        </div>
        <div class="ml-3">
          <h5>Nejvýhodnější cena pro naše klienty</h5>
          <p>
            Pokud jste již našimi klienty, je pro vás tento tarif k dispozici za
            {{ orderFormProgram?.price_vat + (includeIptv ? 99 : 0) }} Kč měsíčně (včetně DPH).
          </p>
        </div>
      </div>
      <div v-if="!includeIptv" class="d-flex align-items-start">
        <div class="tariff-icon-bg mt-1">
          <inline-svg :src="globeSvg" class="svg-icon svg-icon-heavy text-primary"></inline-svg>
        </div>
        <div class="ml-3">
          <h5>Roaming v EU v ceně</h5>
          <p>
            V celé EU, Norsku, Lichtenštejnsku, Velké Británii a na Islandu jste jako doma. Bez starostí a příplatků
            můžete v rámci roamingu využívat služby jako v ČR.
          </p>
        </div>
      </div>
    </div>
  </ModalView>
  <ModalView v-if="isGiftModalVisible" @hide="hideGiftModal">
    <template v-slot:header>
      <h2>Bonusová data</h2>
    </template>
    <div class="text-content">
      <h3><strong>Termín akce</strong></h3>
      <p>Akce platí od 1.1. 2023 do 31. 3. 2023</p>
      <h3><strong>Popis akce</strong></h3>
      <p>
        Zákazníci PODA, kteří si zakoupí mobilní tarif PODA (mimo mobilní tarif PODA ZÁKLAD) s aktivním datovým
        balíčkem, si mohou za symbolickou 1 Kč objednat datový balíček 2 GB, 4 GB nebo 6 GB a to 1x v kalendářním
        měsíci.
      </p>
      <table class="phones-table phones-table-bordered">
        <tbody>
          <tr>
            <td><strong>Data ve vybraném tarifu</strong></td>
            <td><strong>Výše akčního dokupu dat</strong></td>
          </tr>
          <tr>
            <td>2 GB a méně</td>
            <td>2 GB</td>
          </tr>
          <tr>
            <td>2,5 GB - 8 GB</td>
            <td>4 GB</td>
          </tr>
          <tr>
            <td>9 GB a více</td>
            <td>6 GB</td>
          </tr>
        </tbody>
      </table>
      <p>Akce se nevztahuje na tarify PODA ZÁKLAD, PODA NEO bez dat a PODA 400 bez dat.</p>
    </div>
  </ModalView>
  <OnExitModalView
    name="volani-onexit"
    class="modal-view-md"
    v-if="
      showExitIntentPopup &&
      Date.now().valueOf < new Date('2024-06-30').valueOf &&
      !isOrderFormVisible &&
      !isPromoModalVisible
    ">
    <template #header><h2>Nenechte si ujít časově omezenou akci</h2></template>
    <ExitIntentContent />
    <template #footer
      ><div class="text-muted text-sm">
        Údaje zpracujeme dle
        <a href="/ochrana-soukromi/" class="text-muted">Zásad zpracování osobních údajů</a>
        za účelem jednorázového telefonického kontaktu s informacemi o našich službách.
      </div></template
    >
  </OnExitModalView>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { SimTariffGroup } from "@/services/sim-tariffs/SimTariffGroup";
import type { SimTariffProgram } from "@/services/sim-tariffs/SimTariffProgram";
import TariffOrderForm from "@/components/tariff-order-form";
import ModalView from "@/components/modal-view";
import TariffCategoryPicker from "@/components/tariff-category-picker";
import TariffCard from "@/components/tariff-card.vue";
import TariffCardSlider from "@/components/tariff-card-slider";
import OnExitModalView from "@/components/on-exit-modal-view";
import ExitIntentContent from "@/components/exit-intent-content";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import InlineSvg from "vue-inline-svg";

import arrowSvg from "@/assets/img/sim/arrow.svg";
import callSvg from "@/assets/img/sim/call.svg";
import messageSvg from "@/assets/img/sim/message.svg";
import dataSvg from "@/assets/img/sim/data.svg";
import globeSvg from "@/assets/img/sim/world-map.svg";
import piggyBankSvg from "@/assets/img/sim/piggy-bank.svg";

import remoteSvg from "@/assets/img/sim/remote-control.svg";
import networkSvg from "@/assets/img/sim/computer-network.svg";
import playSvg from "@/assets/img/sim/play-movie.svg";

export default defineComponent({
  name: "SimTariffs",
  data() {
    return {
      groups: [] as SimTariffGroup[],
      defaultProgramsIds: {},
      simTariffClientText: "",
      simTariffNonClientText: "",
      promoModalLabel: "",
      promoModalHeading: "",
      promoModalContent: "",
      promoModalNonClientContent: "",
      promoModalIptvContent: "",
      promoCardId: 1,
      promoFrom: null as Date,
      promoUntil: null as Date,
      isClient: false, // see mounted()
      isGiftModalVisible: false,
      isOrderFormVisible: false,
      isPromoModalVisible: false,
      isPromoNonClientModalVisible: false,
      isPromoIptvModalVisible: false,
      isMoreInfoModalVisible: false,
      promoModalProgram: null as SimTariffProgram,
      orderFormProgram: null as SimTariffProgram,
      orderFormStepCurrent: 1,
      orderFormStepsTotal: 3,
      programs: [] as SimTariffProgram[],
      showExitIntentPopup: false,
      swiper: null as typeof Swiper,
      swiperOptions: {
        breakpoints: {
          576: {
            slidesPerView: 1.6,
          },
          768: {
            slidesPerView: 2.2,
          },
          992: {
            slidesPerView: 3.2,
          },
          1400: {
            slidesPerView: 4,
          },
        },
      },
      arrowSvg: arrowSvg,
      callSvg: callSvg,
      messageSvg: messageSvg,
      dataSvg: dataSvg,
      globeSvg: globeSvg,
      piggyBankSvg: piggyBankSvg,
      remoteSvg: remoteSvg,
      networkSvg: networkSvg,
      playSvg: playSvg,
    };
  },
  props: {
    includeIptv: {
      type: Boolean,
      default: false,
      required: false,
    },
    iptvPrice: {
      type: Number,
      default: 0,
      required: false,
    },
    showIsClientPicker: {
      type: Boolean,
      default: true,
      required: false,
    },
    isClientInit: {
      type: Boolean,
      default: true,
      required: false,
    },
    showBottomCaption: {
      type: Boolean,
      default: true,
      required: false,
    },
    showCarrierInfo: {
      type: Boolean,
      default: true,
      required: false,
    },
    gtmEventPrefix: {
      type: String,
      required: false,
      default: "sim_order_form_",
    },
  },

  computed: {
    groupsWhitelist(): string {
      const search = new URLSearchParams(window.location.search);
      return search.get("groups") ?? "";
    },
    dataTitle(): string {
      const data = this.orderFormProgram?.incl_data;
      if (!data) return "";
      return data > 1000 ? this.formatNumber(data / 1000) + " GB dat" : this.formatNumber(data) + " MB dat";
    },
    urlWhitelistedGroups(): SimTariffGroup[] {
      // Whitelist out of order
      // if (this.groupsWhitelist.length === 0) {
      //     return this.groups;
      // }
      // // Checks for each group if whitelisted
      // Checks for each group if whitelisted
      // return Object.fromEntries(
      //     Object.entries(this.groups).filter(([key]) => {
      //         return this.groupsWhitelist.indexOf(key) > -1;
      //     })
      // ); // TODO

      // const result = Object.keys(this.groups).map((val, key) => this.groups[key]);
      // result.forEach((val, i) => {
      //     console.log(val);
      //     if(this.groups[i].programs_id.length === 0 && this.groups[i].programs_id_all.length === 0) {
      //         this.groups = this.groups.splice(i, 1);
      //     }
      // });

      const result = [];

      for (const key of Object.keys(this.groups)) {
        if (this.groups[Number(key)].programs_id.length != 0 && this.groups[Number(key)].programs_id_all.length != 0) {
          result.push(this.groups[Number(key)]);
        }
      }

      return result;
    },
    formType() {
      if (this.includeIptv) {
        return false;
      }
      return this.isClient;
    },
  },
  components: {
    TariffOrderForm,
    ModalView,
    TariffCategoryPicker,
    TariffCard,
    TariffCardSlider,
    Swiper,
    SwiperSlide,
    OnExitModalView,
    ExitIntentContent,
    InlineSvg,
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
    };
  },
  methods: {
    formatNumber(number: number) {
      return number.toLocaleString("cs-CZ", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
        useGrouping: true,
      });
    },
    onSwiper(swiper: typeof Swiper) {
      this.swiper = swiper;
      this.slideToSuggestedTariff();
    },
    async fetchTariffs() {
      this.groups = await this.$store.direct.getters.simTariffService.getGroups();
      this.programs = await this.$store.direct.getters.simTariffService.getPrograms();

      const data = await this.$store.direct.getters.simTariffsService.getData();

      for (const key of Object.keys(this.groups)) {
        this.groups[Number(key)].order = data.tariffs[Number(key)].order;
      }

      this.simTariffClientText = data.sim_tariff_client_text;
      this.simTariffNonClientText = data.sim_tariff_nonclient_text;
    },
    async handleIsClientChange(isClient: boolean) {
      this.isClient = isClient;
    },
    async showOrderForm(tariff: SimTariffProgram) {
      this.orderFormProgram = tariff;
      this.isOrderFormVisible = true;
    },
    async hideOrderForm() {
      this.isOrderFormVisible = false;
    },
    async showPromoModal(selectedProgram: SimTariffProgram) {
      this.promoModalProgram = selectedProgram;
      this.isPromoModalVisible = true;
    },
    async showPromoNonClientModal(selectedProgram: SimTariffProgram) {
      this.promoModalProgram = selectedProgram;
      this.isPromoNonClientModalVisible = true;
    },
    async showPromoIptvModal(selectedProgram: SimTariffProgram) {
      this.promoModalProgram = selectedProgram;
      this.isPromoIptvModalVisible = true;
    },
    async hidePromoModal() {
      this.isPromoModalVisible = false;
    },
    async hidePromoNonClientModal() {
      this.isPromoNonClientModalVisible = false;
    },
    async hidePromoIptvModal() {
      this.isPromoIptvModalVisible = false;
    },
    async showMoreInfoModal(tariff: SimTariffProgram) {
      this.orderFormProgram = tariff;
      this.isMoreInfoModalVisible = true;
    },
    async hideMoreInfoModal() {
      this.isMoreInfoModalVisible = false;
    },
    async showGiftModal() {
      this.isGiftModalVisible = true;
    },
    async hideGiftModal() {
      this.isGiftModalVisible = false;
    },
    async handleStepChange(payload: object) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.orderFormStepCurrent = payload?.current;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.orderFormStepsTotal = payload?.total;
    },
    slideToSuggestedTariff() {
      /*const search = new URLSearchParams(window.location.search);
            this.suggestedGroupId = search.get("group");

            if (this.suggestedGroupId && this.groups) {
                let i = 0;
                for (let index in this.groups) {
                    if (this.groups[index].group_id == this.suggestedGroupId) {
                        this.swiper.slideTo(i, 100);
                    }
                    i++;
                }
            }*/
      return; // TODO
    },
  },
  async created() {
    const simData = await this.$store.direct.getters.simTariffsService.getData();
    this.defaultProgramsIds = simData.tariffs;
    this.promoModalLabel = simData.promo_label;
    this.promoModalHeading = simData.promo_heading;
    this.promoModalContent = simData.promo_content;
    this.promoModalNonClientContent = simData.promo_content_nonclient;
    this.promoModalIptvContent = simData.promo_content_iptv;
    this.promoCardId = simData.promo_card_id;
    this.promoFrom = new Date(simData.promo_from);
    this.promoUntil = new Date(simData.promo_until);
  },
  async mounted() {
    this.isClient = this.isClientInit;
    this.fetchTariffs();

    const showExitIntentDataAttribute = this.$el?.parentElement?.dataset.showExitIntent;
    if (showExitIntentDataAttribute !== undefined) {
      this.showExitIntentPopup = Boolean(showExitIntentDataAttribute);
    }
  },
});
</script>
